module.exports = __webpack_public_path__ + "img/10.a8241d5a.jpg";